import { useEffect } from "react";
import { useSelector } from "react-redux";

import { RootState } from "../globals";
import { iniciarNoLeidosCorreo } from "./noLeidos";

/** No dibuja nada: mantiene al día el globito de WappMail en el menú mientras la persona tenga la sección. */
export const CorreoNoLeidos = () => {
	const campusId: number = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampusId);
	const userMenu: any[] = useSelector((state: RootState) => state.userMenu.value);
	const tiene = (userMenu || []).some((b: any) => (b?.sections || []).some((x: any) => x?.route === "wappmail"));
	useEffect(() => (campusId && tiene ? iniciarNoLeidosCorreo(campusId) : undefined), [campusId, tiene]);
	return null;
};
